import { find } from 'lodash';

class CategorySelectController {
  constructor(categoriesService) {
    this.categoriesService = categoriesService;
  }

  $onInit(){
    this.categoriesService.findAll(-1).then(result => {
        this.categorylist = result;
        this.categories = (this.ngModel.$viewValue && Object.keys(this.ngModel.$viewValue).length ? this.ngModel.$viewValue : []);
    });
  }

  updateValue(isOpen = false){
    if (!isOpen) {
      this.ngModel.$setViewValue(this.categories);
      this.ngModel.$setTouched();
    }
  }

  delete(key){
    if (Object.keys(this.categories).length === 1){
        this.categories = [];
    }
    else{
        this.categories.splice(key, 1);
    }
    this.updateValue();
  }

  disablecategory(id){
    return find(this.categories, {'category_id': id});
  }
}

CategorySelectController.$inject = [ 'categoriesService' ];

export default CategorySelectController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/category.select.controller.js